import { render } from "./clientsResveration.vue?vue&type=template&id=76d4e124&scoped=true"
import script from "./clientsResveration.vue?vue&type=script&lang=js"
export * from "./clientsResveration.vue?vue&type=script&lang=js"

import "./clientsResveration.vue?vue&type=style&index=0&id=76d4e124&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76d4e124"]])

export default __exports__